import { render, staticRenderFns } from "./CustomFieldBuilder.vue?vue&type=template&id=2e217ea2&scoped=true"
import script from "./CustomFieldBuilder.vue?vue&type=script&lang=js"
export * from "./CustomFieldBuilder.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldBuilder.vue?vue&type=style&index=0&id=2e217ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e217ea2",
  null
  
)

export default component.exports